import { useState } from "react";
import ConfirmationDialog from "./ConfirmationDialog"; // adjust path if needed
import { useGlobalState } from "../contexts/GlobalStateContext";

export default function ResetPassword({ email, code, onClose }) {
  const [newPassword1, setNewPassword1] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [notice, setNotice] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [success, setSuccess] = useState(false); // new state to track success
  const { resetGlobalState, logOut } = useGlobalState();
  const validatePasswords = () => {
    if (!newPassword1 || !newPassword2) {
      setNotice("Please fill in all fields.");
      return false;
    }

    if (newPassword1 !== newPassword2) {
      setNotice("Passwords do not match.");
      return false;
    }

    if (newPassword1.length < 8) {
      setNotice("Password must be at least 8 characters long.");
      return false;
    }

    if (!/[a-z]/.test(newPassword1)) {
      setNotice("Password must contain at least one lowercase letter.");
      return false;
    }

    if (!/[A-Z]/.test(newPassword1)) {
      setNotice("Password must contain at least one uppercase letter.");
      return false;
    }

    if (!/\d/.test(newPassword1)) {
      setNotice("Password must contain at least one number.");
      return false;
    }

    if (!/[\s!@#$%^&*()\-_=+{};:,<.>?]/.test(newPassword1)) {
      setNotice("Password must contain at least one symbol.");
      return false;
    }

    return true;
  };

  const handlePreConfirm = () => {
    if (validatePasswords()) {
      setShowConfirm(true);
    }
  };

  const resetPassword = async () => {
    try {
      const res = await fetch("/php/resetPassword.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, code, newPassword: newPassword1 }),
      });

      const data = await res.json();

      if (data.success) {
        setNotice("Your password has been reset successfully.");
        setSuccess(true); // hide form
      } else if (data.status === "error") {
        logOut();
        resetGlobalState();
      } else {
        setNotice("Failed to reset password. The prompt may have expired.");
      }
    } catch (error) {
      console.error("Error:", error);
      setNotice("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <div className="update-setting-modal" style={{ display: "block" }}>
        <div className="setting-content">
          <div id="comments-header">
            <span id="modal-title">Reset Password</span>
            <span className="close" onClick={onClose}>
              &times;
            </span>
          </div>

          {notice && (
            <div
              className="notice"
              style={{
                color: notice.includes("successfully") ? "green" : "red",
                margin: "40px auto",
              }}
            >
              {notice}
            </div>
          )}

          {!success && (
            <>
              <input
                type="password"
                className="fullTextbox"
                placeholder="Enter new password"
                value={newPassword1}
                onChange={(e) => setNewPassword1(e.target.value)}
                autoComplete="new-password"
              />
              <input
                type="password"
                className="fullTextbox"
                placeholder="Re-enter new password"
                value={newPassword2}
                onChange={(e) => setNewPassword2(e.target.value)}
                autoComplete="new-password"
              />

              <button
                style={{ backgroundColor: "#3DDC84" }}
                className="confirm"
                onClick={handlePreConfirm}
              >
                Confirm
              </button>
            </>
          )}
        </div>
      </div>

      <ConfirmationDialog
        show={showConfirm}
        action="save"
        onConfirm={() => {
          setShowConfirm(false);
          resetPassword();
        }}
        onCancel={() => setShowConfirm(false)}
      />
    </>
  );
}
